import { render, staticRenderFns } from "./PHorizontalCardListItem.vue?vue&type=template&id=04eef18c&scoped=true&"
import script from "./PHorizontalCardListItem.vue?vue&type=script&lang=ts&"
export * from "./PHorizontalCardListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PHorizontalCardListItem.vue?vue&type=style&index=0&id=04eef18c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eef18c",
  null
  
)

export default component.exports